/**
 * Retourne le tenant courant
 * @param url
 * @param file
 * @returns {string}
 */
export const getTenant = () => process.env.REACT_APP_ID;

/**
 * Retourne le tenant courant en uppercase
 * @param url
 * @param file
 * @returns {string}
 */
export const getTenantUppercase = () => process.env.REACT_APP_ID.toUpperCase();

/**
 * Retourne le svg avec la bonne charte graphique en fonction du tenant
 * @param url
 * @param file
 * @returns {string}
 */
export const getSvgEnFonctionDuTenant = (url, file) => url + getTenant() + file;

/**
 * Flag d'affichage de l'email de contact dans le volet d'aide
 * @returns {boolean}
 */
export const isEmailDeContactDisplayed = () => process.env.REACT_APP_CONTACT_EMAIL_DISPLAYED === 'true';

/**
 * Ajout de l'email dans le formulaire d'identité pour générali
 * @returns {boolean}
 */
export const isUtilisateurAutoriseASInscrire = () => process.env.REACT_APP_UTILISATEUR_AUTORISE_A_S_INSCRIRE === 'true';

/**
 * Flag d'affichage du deuxième bloc info sur la page de saisie du SIRET
 * @returns {boolean}
 */
export const isSiretInfoPartie2Enabled = () => process.env.REACT_APP_SIRET_INFO_PART_2_ENABLED === 'true';

/**
 * Autorisation de la redirection vers le portail après déconnexion
 * @returns {boolean}
 */
export const isDeconnexionVersPortailEnabled = () => process.env.REACT_APP_DECONNEXION_VERS_PORTAIL_ENABLED === 'true';

/**
 * Flag d'affichage de la page tarification version YOMONI
 * @returns {boolean}
 */
export const isFraisConseilEnabled = () => process.env.REACT_APP_FRAIS_CONSEIL_ENABLED === 'true';
/**
 * Flag d'affichage du mode participation volontaire
 * @returns {boolean}
 */
export const isParticipationVolontaireEnabled = () => process.env.REACT_APP_PARTICIPATION_VOLONTAIRE_ENABLED === 'true';

/**
 * Flag d'affichage du bloc info sur la page d'intéressement
 * @returns {boolean}
 */
export const isMessagesAccompagnementAccordsEnabled = () =>
  process.env.REACT_APP_MESSAGES_ACCOMPAGNEMENT_ACCORDS_ENABLED === 'true';

/**
 * Flag d'ouverture pour les routes suivantes :
 * - Création de compte
 * - Login
 * - Mot de passe oublié
 * - Récupération de mot de passe
 * @returns {boolean}
 */
export const isRoutesAuthentificationEnabled = () => process.env.REACT_APP_ROUTES_AUTHENTIFICATION_ENABLED === 'true';

/** Flag autorisant l'affichage de la liste de ratification dans les documents à uploader
 * @returns {boolean}
 */
export const isUploadListeRatificationEnabled = () => process.env.REACT_APP_UPLOAD_LISTE_RATIFICATION_ENABLED === 'true';

/**
 * Flag d'affichage des sources de versement abondées
 * @returns {boolean}
 */
export const isSourcesVersementAbondeesEnabled = () => process.env.REACT_APP_SOURCES_VERSEMENT_ABONDEES_ENABLED === 'true';

/**
 * Flag d'affichage des sources de versement abondées
 * @returns {boolean}
 */
export const isPeiPercoiIndependantEnabled = () => process.env.REACT_APP_PEI_PERCOI_SEUL_ENABLED === 'true';

/**
 * Flag d'aide à la completion du dossier après signature
 * @returns {boolean}
 */
export const isCumulPercoiAbondementUnilateralEnabled = () =>
  process.env.REACT_APP_CUMUL_PERCOI_ABONDEMENT_UNILATERAL_ENABLED === 'true';

/**
 * Flag d'affichage de la partie infos de la page votre entreprise
 * @returns {boolean}
 */
export const isInfoCardEntreprisePart1Enabled = () => process.env.REACT_APP_ENTREPRISE_INFO_1_ENABLED === 'true';

/**
 * Flag d'affichage du volet d'infos sur la page du dirigeant
 * @returns {boolean}
 */
export const isDirigeantInfoEnabled = () => process.env.REACT_APP_DIRIGEANT_INFOS_ENABLED === 'true';
